import { CapoPlugin } from "/builds/nht4944308/products/malarkey/malarkey-nuxt-web-app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];